// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminHeader-modules__wrapper__vJf9b"};